import React, { useEffect } from "react";
import EnChat_Icon_01 from "../../assets/EnChat_Icon_01.png"; // แก้ชื่อไฟล์ตามจริง

export default function EnChatInfo() {
  useEffect(() => {
    document.title = "ข้อมูลเกี่ยวกับ EnChat (IO-1) - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-3">ข้อมูลเกี่ยวกับ EnChat</h1>
            <p className="text-muted mb-4">
              ภาพรวมเวอร์ชั่น EnChat/IO-1 ที่ใช้งานบนเว็บไซต์ encraft.org
            </p>

            {/* การ์ดหลัก + โลโก้ IO-1 */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5 text-center">
                <div className="mb-3">
                  <img
                    src={EnChat_Icon_01}
                    alt="EnChat IO-1"
                    style={{
                      maxWidth: "180px",
                      width: "100%",
                      borderRadius: "24px",
                    }}
                  />
                </div>
                <h2 className="h4 mb-1">EnChat / IO-1</h2>
                <p className="text-muted mb-2">
                  เวอร์ชั่นแรกของ EnChat สำหรับหน้าอ่านบทความบน encraft.org
                </p>
                <span className="badge rounded-pill bg-success-subtle text-success me-2">
                  สถานะ: active
                </span>
                {/* <span className="badge rounded-pill bg-primary-subtle text-primary me-2">
                  Tier: สมาชิก (member)
                </span> */}
                <span className="badge rounded-pill bg-light text-muted">
                  รุ่น: IO-1
                </span>
              </div>
            </div>

            {/* ภาพรวม */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">ภาพรวมของ EnChat / IO-1</h2>
                <p>
                  <strong>EnChat / IO-1</strong> เป็นเวอร์ชั่นแรกของระบบแชต AI
                  บนเว็บไซต์ encraft.org ที่ออกแบบมาเพื่อช่วยผู้อ่าน
                  ทำความเข้าใจเนื้อหาในบทความให้ลึกขึ้น
                  โดยเน้นตอบคำถามจากเนื้อหาในหน้า{" "}
                  <strong>อ่านบทความ</strong> และจัดรูปแบบคำตอบให้อ่านง่าย
                </p>
                <p className="mb-0">
                  เป้าหมายของ IO-1 คือเป็นผู้ช่วยที่เข้าใจบริบทของบทความ
                  สามารถสรุป อธิบาย หรือแตกประเด็นเนื้อหาให้เข้าใจง่ายขึ้น
                  โดยเฉพาะสำหรับผู้เริ่มต้นหรือผู้ใช้งานด้าน AI และ Automation
                </p>
              </div>
            </div>

            {/* Technical overview */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">รายละเอียดเชิงเทคนิค (Technical Info)</h2>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="mb-0">
                      <li>
                        <strong>Code:</strong> <code>enchat/io-1</code>
                      </li>
                      <li>
                        <strong>ชื่อที่แสดง:</strong> EnChat / IO-1
                      </li>
                      <li>
                        <strong>Short label:</strong> IO-1
                      </li>
                      <li>
                        <strong>Status:</strong> active
                      </li>
                      <li>
                        <strong>Available Tier:</strong> Guest, Member
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="mb-0">
                      <li>
                        <strong>Model:</strong>
                        <br/>- gpt-4o-mini (Guest)
                        <br/>- gpt-5-mini (Member)
                      </li>
                      <li>
                        <strong>Provider:</strong> openai
                      </li>
                      <li>
                        <strong>Temperature:</strong> 0.3
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* ความสามารถ / ข้อจำกัด */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">ความสามารถหลัก (Capabilities)</h2>
                <ul>
                  <li>ตอบคำถามจากเนื้อหาในหน้าบทความ</li>
                  <li>จัดข้อความเป็นหัวข้อและ bullet points ให้อ่านง่าย</li>
                  <li>อธิบายเนื้อหาแบบเข้าใจง่ายสำหรับผู้เริ่มต้น</li>
                </ul>

                <h2 className="h5 mt-4 mb-3">ข้อจำกัด (Limitations)</h2>
                <ul>
                  <li>ไม่ตอบคำถามที่ไม่เกี่ยวกับบทความในหน้านั้น</li>
                  <li>ไม่ใช้สำหรับให้คำปรึกษาทางกฎหมายหรือการแพทย์</li>
                  <li>คำตอบอาจไม่สมบูรณ์หากบทความมีเนื้อหาน้อยมาก</li>
                </ul>
              </div>
            </div>

            {/* Data usage & policy */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">การใช้ข้อมูล (Data usage และ Privacy)</h2>
                <ul>
                  <li>
                    <strong>Store Conversations:</strong>{" "}
                    <code>false</code> – ระบบ Encraft
                    ไม่ได้เก็บ log การสนทนาของผู้ใช้ในเวอร์ชั่นนี้ และจะจัดเก็บได้ก็ต่อเมื่อได้รับความยินยอมจากผู้ใช้
                  </li>
                  <li>
                    ข้อความแชทอาจถูกส่งไปยัง OpenAI เพื่อใช้ในการประมวลผลคำตอบ
                    แต่ระบบจะไม่เก็บข้อมูลส่วนบุคคลโดยตั้งใจ
                  </li>
                  <li>
                    ไม่ควรป้อนข้อมูลที่อ่อนไหว เช่น เลขบัตรประชาชน รหัสผ่าน
                    หรือข้อมูลส่วนบุคคลที่ละเอียดอ่อนผ่าน EnChat
                  </li>
                </ul>

                <p className="small text-muted mb-0">
                  รายละเอียดเพิ่มเติมเกี่ยวกับการเก็บและใช้ข้อมูลอ่านได้ในหน้า{" "}
                  <a href="/privacy">นโยบายความเป็นส่วนตัว</a>.
                </p>
              </div>
            </div>

            {/* Usage Policy */}
            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">แนวทางการใช้งาน (Usage Policy)</h2>
                <pre className="bg-light p-3 rounded small mb-0">
{`- ห้ามใช้ EnChat เพื่อถามคำถามที่ผิดกฎหมาย หรือขัดต่อข้อกำหนดของเว็บไซต์
- ห้ามป้อนข้อมูลส่วนบุคคลที่อ่อนไหว เช่น เลขบัตรประชาชน รหัสผ่าน ฯลฯ`}
                </pre>
              </div>
            </div>

            {/* Firestore rules & document example */}
            {/* <div className="card border-0 shadow-sm mb-4">
              <div className="card-body p-4 p-md-5"> */}
                {/* <h2 className="h5 mb-3">โครงสร้างใน Firestore</h2>
                <p>
                  ข้อมูลของ EnChat แต่ละเวอร์ชันจะถูกเก็บไว้ใน collection{" "}
                  <code>enchat</code> โดยใช้ document แยกตามเวอร์ชั่น เช่น{" "}
                  <code>io-1</code> เป็นต้น
                </p> */}

                {/* <h3 className="h6 mt-3">ตัวอย่าง Firestore Security Rules</h3>
                <pre className="bg-dark text-light p-3 rounded small mb-4">
                    {`// ต่อจาก rules เดิมของคุณ

                    match /enchat/{docId} {
                    // ใครก็อ่านได้
                    allow read: if true;

                    // เขียนได้เฉพาะ admin
                    allow create, update, delete: if isAdmin() && validEnchatDoc();

                    function validEnchatDoc() {
                        // ป้องกัน field แปลก ๆ หลุดเข้าไป
                        return request.resource.data.keys().hasOnly([
                        'code',
                        'name',
                        'shortLabel',
                        'status',
                        'tier',
                        'model',
                        'provider',
                        'temperature',
                        'description',
                        'capabilities',
                        'limitations',
                        'dataUsage',
                        'usagePolicy',
                        'changeLog',
                        'sortOrder',
                        'public',
                        'createdAt',
                        'updatedAt'
                        ]);
                    }
                    }`}
                </pre> */}

                {/* <h3 className="h6 mt-3">ตัวอย่าง document: <code>enchat/io-1</code></h3>
                <pre className="bg-light p-3 rounded small mb-0">
{`{
  code: "enchat/io-1",           // รหัสภายใน
  name: "EnChat / IO-1",         // ชื่อที่แสดงในเว็บ
  shortLabel: "IO-1",            // ถ้าใช้ใน badge / ปุ่ม
  status: "active",              // active | deprecated | beta
  tier: "member",                // guest | member | pro (เข้าถึงด้วย role แบบไหน)

  model: "gpt-5-mini",
  provider: "openai",
  temperature: 0.3,

  description: "เวอร์ชั่นแรกของ EnChat ที่เน้นตอบเฉพาะเนื้อหาบทความ พร้อมจัดรูปแบบสวยงาม",
  capabilities: [
    "ตอบคำถามจากเนื้อหาในหน้าบทความ (ArticlePage)",
    "จัดข้อความเป็นหัวข้อและ bullet points ให้อ่านง่าย",
    "อธิบายเนื้อหาแบบเข้าใจง่ายสำหรับผู้เริ่มต้น"
  ],
  limitations: [
    "ไม่ตอบคำถามที่ไม่เกี่ยวกับบทความในหน้านั้น",
    "ไม่ใช้สำหรับให้คำปรึกษาทางกฎหมาย/การแพทย์",
    "คำตอบอาจไม่สมบูรณ์หากบทความมีเนื้อหาน้อยมาก"
  ],

  dataUsage: {
    storeConversations: false,   // เก็บ log แชทไหม (ของคุณ)
    note: "ข้อความแชทอาจถูกส่งไปยัง OpenAI เพื่อประมวลผล แต่ระบบจะไม่เก็บข้อมูลส่วนบุคคลโดยตั้งใจ"
  },

  usagePolicy: \`
- ห้ามใช้ EnChat เพื่อถามคำถามที่ผิดกฎหมาย หรือขัดต่อข้อกำหนดของเว็บไซต์
- ห้ามป้อนข้อมูลส่วนบุคคลที่อ่อนไหว เช่น เลขบัตรประชาชน รหัสผ่าน ฯลฯ
  \`.trim(),

  changeLog: [
    {
      version: "1.0.0",
      date: "2025-11-15",
      notes: [
        "เปิดตัว EnChat / IO-1 สำหรับหน้าอ่านบทความ",
        "รองรับ Markdown + bullet points"
      ]
    }
  ],

  sortOrder: 1,                  // ใช้จัดลำดับการเรียงบนหน้าเว็บ
  public: true,                  // พร้อมให้โชว์ในหน้า info หรือยัง

  createdAt: <timestamp>,
  updatedAt: <timestamp>
}`}
                </pre> */}
              {/*  </div> 
            </div> */}

            <p className="text-muted small">
              เอกสารนี้อธิบายเฉพาะเวอร์ชั่น EnChat / IO-1 ในอนาคตหากมีรุ่นอื่น ๆ
              (เช่น IO-2, Pro ฯลฯ) จะมีการอัปเดตข้อมูลเพิ่มเติมในหน้านี้
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
